// extracted by mini-css-extract-plugin
export default {"container":"ImgGallery_container__si2mp","note":"ImgGallery_note__h5Knn"};